import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCircle, Info, Warning, Error } from "@mui/icons-material";

interface CustomAlertProps {
  severity?: "info" | "success" | "warning" | "error";
  children: React.ReactNode;
  sx?: any;
}

export const CustomAlert: React.FC<CustomAlertProps> = ({
  severity = "info",
  children,
  sx = {},
}) => {
  const getIcon = () => {
    switch (severity) {
      case "success":
        return <CheckCircle sx={{ color: "#4caf50", fontSize: 20 }} />;
      case "warning":
        return <Warning sx={{ color: "#ff9800", fontSize: 20 }} />;
      case "error":
        return <Error sx={{ color: "#f44336", fontSize: 20 }} />;
      default:
        return <Info sx={{ color: "#2196f3", fontSize: 20 }} />;
    }
  };

  const getColors = () => {
    switch (severity) {
      case "success":
        return {
          backgroundColor: "#f1f8e9",
          borderColor: "#c8e6c9",
          textColor: "#2e7d32",
        };
      case "warning":
        return {
          backgroundColor: "#fff8e1",
          borderColor: "#ffcc02",
          textColor: "#f57c00",
        };
      case "error":
        return {
          backgroundColor: "#ffebee",
          borderColor: "#ffcdd2",
          textColor: "#c62828",
        };
      default:
        return {
          backgroundColor: "#f8f9fa",
          borderColor: "#e3f2fd",
          textColor: "#1976d2",
        };
    }
  };

  const colors = getColors();

  return (
    <Box
      sx={{
        mb: 4,
        p: 2,
        backgroundColor: colors.backgroundColor,
        border: `1px solid ${colors.borderColor}`,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        ...sx,
      }}
    >
      {getIcon()}
      <Typography
        variant="body2"
        sx={{
          color: colors.textColor,
          fontWeight: 500,
          lineHeight: 1.4,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};
